<template>
	<div>
		<s-crud
			title="Responsable de Paradas"
            ref="gridResponsible"
			:config="config"  
            :filter="filter"       
			add			
			edit
            remove
            add-no-function     	
			search-input
            @rowSelected="rowSelected($event)"
            @add="add()"
            @edit="edit()"
		>

            <template v-slot:options>
                <v-tooltip bottom="">
                    <template v-slot:activator="{ on }">
                        <v-btn
                        v-on="on"
                        text
                        black 
                        @click="removedFunc()"
                        small
                        >
                            <v-icon>mdi-minus-circle-outline</v-icon>
                        </v-btn>
                    </template>
                    <span>Eliminar</span>
                </v-tooltip>
            </template>

            <template v-slot:CrpState="{ row }">
				<v-chip x-small=""  :color="row.CrpState == 1 ? 'success': 'error'" >
					{{ row.CrpState == 1 ? 'Activo': 'Inactivo' }}
				</v-chip>
        	</template>

            <template v-slot:NumberMotivos="{ row }">
				<v-chip x-small=""  :color="row.NumberMotivos > 0 ? 'warning': 'error'" >
					{{ row.NumberMotivos }}
				</v-chip>
        	</template> 
		</s-crud> 
        <v-dialog max-width="auto" v-model="openDialog" persistent v-if="openDialog" width="900">
            <responsible-detail @save="save()" @close="close()" :selectGroup="selectGroup" v-model="RsdID" :CrpID="Resposible"></responsible-detail>
        </v-dialog> 
	</div>
</template>



<script>
	import _sFrzCtnResponsibleStopService from "@/services/FrozenProduction/FrzCtnResponsibleStopService.js";
    import ResponsibleDetail from "./FrzCtnResponsibleStopDetail.vue"
    

	export default {
        components: { ResponsibleDetail },
		data: () =>({

            config: {
                model: {
                    CrpID: "ID",
                    CrpState:"",
                    NumberMotivos:""
                },
                service: _sFrzCtnResponsibleStopService,
                headers: [
                    {text: "ID", value: "CrpID"},
                    {text: "Descripcion", value: "CrpDescription"},
                    {text: "Estado", value: "CrpState"},
                    {text: "N° Motivos", value: "NumberMotivos"}
                ]
            },
            filter: { CrpDescription: ''},
            openDialog: false,
            RsdID: 0,
            selectGroup: [],
            Resposible: 0,

		}),
 
		methods: {

            add()
            {              
                this.Resposible = 0;
                this.selectGroup = [];
                this.openDialog = true;
                console.log('agregar');
            },
            edit(){                             
                this.openDialog = true;
            },
            close(){                
                this.openDialog = false;
                this.RsdID = '';
                this.selectGroup = [];
                this.$refs.gridResponsible.refresh();
            },
            removedFunc(){
                const item = {...this.selectGroup[0]};
                item.UsrCreateID = this.$fun.getUserID();
                item.UsrUpdateID = this.$fun.getUserID();
                item.SecStatus = 0;

                for (let index = 0; index < item.FrzCtnResponsibleStopDetail.length; index++) {
                    const element = item.FrzCtnResponsibleStopDetail[index];
                    element.UsrCreateID = this.$fun.getUserID();
                    element.UsrUpdateID = this.$fun.getUserID();
                    element.SecStatus = 0;
                }

                this.$fun.alert("Estas seguro de eliminar?", "question").then((r) => {
                    if(r.value){
                
                        _sFrzCtnResponsibleStopService.save(item, this.$fun.getUserID()).then((r) => {
                            if (r.status == 200) {
                                this.$fun.alert("Eliminado correctamente", "success");
                                this.$refs.gridResponsible.refresh();
                            }
                        });
                    }
                })
            },

            save(){
                this.$refs.gridResponsible.refresh();
            },
            
            rowSelected(item){
                console.log('load', item);
                // this.Resposible = 0;
                this.selectGroup = item;
                this.RsdID = this.selectGroup.length > 0 ? this.selectGroup[0].CrpID : 0;
                
                if (item[0].CrpID){
                    this.Resposible = item[0].CrpID;

                    _sFrzCtnResponsibleStopService.listdetail({ CrpID: item[0].CrpID }, this.$fun.getUserID())
                    .then((r) => {
                        if (r.status == 200) {
                            r.data.forEach((el, index) => {
                                el.Line = index + 1;
                            });
                            item[0].FrzCtnResponsibleStopDetail = r.data;
                            this.selectGroup = item;
                            console.log('Detalles',item)
                        }
                    
                    })
                }
            },
        },
            
	}
</script>